import script from "./KActionBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./KActionBtn.vue?vue&type=script&setup=true&lang=ts"

import "./KActionBtn.vue?vue&type=style&index=0&id=0082253c&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0082253c"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
